/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-underscore-dangle */
import { Signal } from 'typed-signals';
import type { Container } from 'pixi.js';
import { setRelativePosition } from './populateLayouts/setRelativePosition';
import { createView } from './populateLayouts/createView';
import { ModelType, type AnyModel } from './populateLayouts/types/models';
import { createInnerLayout } from './populateLayouts/createInnerLayout';
import { preloadLayoutRootBundles } from '../../views/preloadLayoutsAssets';

export const onLayoutPopulated = new Signal<(layout: any) => void>();

const layoutsCache = new Map<any, Set<any>>();

function addToLayoutsCache(layout: any): void {
  const layoutConstructor = layout.constructor;
  const layouts = layoutsCache.get(layoutConstructor) ?? new Set();
  layoutsCache.set(layoutConstructor, layouts);
  layouts.add(layout);
}

function removeFromLayoutsCache(layout: any): void {
  const layoutConstructor = layout.constructor;
  const layouts = layoutsCache.get(layoutConstructor);
  layouts?.delete(layout);
}

export function getAllInstancesOfLayout(layoutConstructor: any): any[] {
  const layouts = layoutsCache.get(layoutConstructor);
  return (layouts ? [...layouts] : []) as any[];
}

export function populate<T extends Record<string, any>>(layout: T, raw: any): void {
  const nestedObjectById: Record<string, any> = {};
  const map: Record<string, any> = {};

  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  Object.values(raw.list).forEach((m) => {
    const model = m as {
      className: string;
      id: string;
      name: string;
      parent: any;
      data: any;
      type: any;
    };

    if (model.data?.DEBUG) {
      return;
    }

    const classNames = model.className
      .split(',')
      .map((v: string) => v.trim())
      .filter((v) => v !== '');
    classNames.forEach((className) => {
      (layout as any)[className] = layout[className] || [];
    });

    let view: Container;
    let object: any;

    if (model.type === ModelType.Layout) {
      const nestedLayout = createInnerLayout(model as AnyModel<ModelType.Layout>);

      if (!nestedLayout) return;

      if (model.data) {
        nestedLayout.layout.data = model.data;
      }

      view = nestedLayout.root;
      object = nestedLayout.layout;
      onLayoutCreated(object, view);

      nestedObjectById[model.id] = object;
    } else {
      const result = createView(model as AnyModel<any>);
      view = result.view;
      object = result.object;
    }

    map[model.id] = view;
    if (map[model.parent]) {
      map[model.parent].addChild(view);
    }

    if (model.name) {
      (layout as any)[model.name] = object;
    }

    classNames.forEach((className) => {
      layout[className].push(object);
    });

    if (model.data) {
      object.data = model.data;
      (layout as any).data = model.data;
    }
  });

  if (!raw.list?.length) {
    console.error('Layout has empty list');
    return;
  }
  const rootModel = raw.list[0];
  const rootView = layout[rootModel.name];

  if (rootModel?.data?.bundlesToPreload) {
    void preloadLayoutRootBundles(rootModel.data.bundlesToPreload);
  }

  setRelativePosition(rootView, raw.x, raw.y, rootModel.x, rootModel.y);

  (layout as any)._viewById = map;
  (layout as any)._nestedObjectById = nestedObjectById;

  onLayoutCreated(layout, rootView);
}

function onLayoutCreated(layout: any, rootView: Container): void {
  onLayoutPopulated.emit(layout);
  addToLayoutsCache(layout);
  rootView.on('destroyed', () => {
    removeFromLayoutsCache(layout);
  });
}
